import React, { useState } from 'react'
import {
  List,
  Form,
  Card,
  InputNumber,
  Avatar,
  message,
  Row,
  Col,
  Button,
  Tooltip,
  Spin,
  Divider
} from 'antd'
import LockOutlined from '@ant-design/icons/lib/icons/LockOutlined'
import InfoCircleOutlined from '@ant-design/icons/lib/icons/InfoCircleOutlined'
import ds from '../../Services/DataServices'
import { useSelector, useDispatch } from 'react-redux'
// import Spinner from "reactstrap/lib/Spinner";
import {
  loadSalesOrderStatuses,
  loadCurrentSalesOrderStatusID,
  loadIsMainLoading,
  loadIsPaymentPanelActionCompleteActive,
  loadStorePaymentTypes,
  loadCustomerObj,
  loadFormAmountToPay,
  loadIsPaymentPanelLoading,
  loadEarnedLoyalty,
  loadSaleRemainingAmount
} from '../../appRedux/actions/MainSale'
import {
  loadCustomerSearchData,
  loadIsShowCompleteSale,
  loadNumPadType,
  loadNumRelateData,
  loadShowNumPadForPay
} from '../../appRedux/actions/Sell'
import {
  SellProductJsonBuilder,
  CalculateReceiptTemplateJson
} from '../../appRedux/actions/SellScreenMethods'
import {
  ApplyCustomerAccountDetails,
  EnableDisableSaleStatusesByCustomer,
  getDecryptID,
  onAccLayBySaleEffects,
  isEmptyObject,
  clusterCalculations,
  closingNumPad
} from '../../appRedux/actions/GlobalMethods'
import { loadPaymentStatusData } from '../../appRedux/actions/CommonData'
import PaymentTypesModal from '../Payments/PaymentTypesModal'
import SearchCustomer from '../SearchCustomer'
import { loadSalePaymentData } from '../../appRedux/actions/Sell'
import CustomScrollbars from '../../util/CustomScrollbars'
import { userLogOut } from '../../appRedux/actions/Auth'
import IntlMessages from '../../util/IntlMessages'
import { BEHAVIOUR_TYPE } from '../../Services/DataServices'
import {
  customParse,
  disableAccLayBy,
  disableCertainStorePay,
  fetchCurrentSalesOrder,
  formatDigits,
  getSalesOrderID,
  notAllowMsgCheck,
  parseFloatCustom
} from '../../appRedux/actions'
import { isEmpty } from 'lodash'
import { PAY_PAY_MODE } from '../../constants/StoreSetting'
import { NumPadTypes } from '../../constants/MobAppConstants'
import NumPad from './NumPad'
import PaymentPanelSummaryHelper_1 from './PaymentPanelSummaryHelper_1'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const PaymentPanelAction = props => {
  const {
    storeCreditPerm,
    returnStoreCredit,
    getLaySalePerm,
    getAccountSalePerm,
    outletid,
    allowPrint,
    getCurrData,
    singleScreen
  } = props
  const dispatch = useDispatch()
  const [form] = Form.useForm()

  const getCustomerObj = useSelector(({ MainSale }) => MainSale.getCustomerObj)
  const getCustomerAccountDetails = useSelector(
    ({ MainSale }) => MainSale.getCustomerAccountDetails
  )
  const getSalesOrderStatuses = useSelector(
    ({ MainSale }) => MainSale.getSalesOrderStatuses
  )
  const getStorePaymentTypes = useSelector(
    ({ MainSale }) => MainSale.getStorePaymentTypes
  )
  const getIsStoreCreditEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsStoreCreditEnabled
  )
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  )
  const getReduxSaleProductJsonData = useSelector(
    ({ Sell }) => Sell.saleProductJsonData
  )
  const getSaleOrderJson = useSelector(
    ({ MainSale }) => MainSale.getSaleOrderJson
  )
  const formAmountToPay = useSelector(({ MainSale }) => MainSale.amountToPay)
  const getSelectedReg = useSelector(({ MainSale }) => MainSale.getSelectedReg)
  const getStoredBooks = useSelector(({ Sell }) => Sell.salePriceBooks)
  const getStoredPromos = useSelector(({ Sell }) => Sell.salePromotions)
  const getIsSalePaymentProcessStart = useSelector(
    ({ MainSale }) => MainSale.getIsSalePaymentProcessStart
  )
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  )
  const getBasicIsPercent = useSelector(
    ({ MainSale }) => MainSale.getBasicIsPercent
  )
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  )
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  )
  const getDefaultLoyaltyAmount = useSelector(
    ({ MainSale }) => MainSale.getDefaultLoyaltyAmount
  )
  const getSelectedOutlet = useSelector(
    ({ commonConfigs }) => commonConfigs.getSelectedOutlet
  )
  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  )
  const getCurrentSalesOrderStatusID = useSelector(
    ({ MainSale }) => MainSale.getCurrentSalesOrderStatusID
  )
  const getEarnedLoyalty = useSelector(
    ({ MainSale }) => MainSale.getEarnedLoyalty
  )
  const getSalePayments = useSelector(
    ({ MainSale }) => MainSale.getSalePayments
  )
  const getAccLaybyCreditAmount = useSelector(
    ({ MainSale }) => MainSale.getAccLaybyCreditAmount
  )
  const getTableDataSellTax = useSelector(
    ({ MainSale }) => MainSale.getTableDataSellTax
  )
  const getReduxStoreInfo = useSelector(
    ({ commonConfigs }) => commonConfigs.getStoreInfo
  )
  const getDiscountPriceTotal = useSelector(
    ({ MainSale }) => MainSale.getDiscountPriceTotal
  )
  const getTableDataSellPromotion = useSelector(
    ({ MainSale }) => MainSale.getTableDataSellPromotion
  )
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getSaleCompleted = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPanelActionCompleteActive
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  const getIsPaymentPanelLoading = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPanelLoading
  )
  const getIsSalePanelActive = useSelector(
    ({ MainSale }) => MainSale.getIsSalePanelActive
  )
  const sellSelAttributes = useSelector(({ Sell }) => Sell.sellSelAttributes)
  const isOnline = useSelector(({ commonConfigs }) => commonConfigs.isOnline)
  const getSavings = useSelector(({ MainSale }) => MainSale.getTotalSaving)
  const formDiscPer = useSelector(({ MainSale }) => MainSale.formDiscPer)
  const formDiscCurr = useSelector(({ MainSale }) => MainSale.formDiscCurr)
  const formSellNote = useSelector(({ MainSale }) => MainSale.formSellNote)
  const getRefundKeys = useSelector(({ MainSale }) => MainSale.getRefundKeys)
  const getAmountDiff = useSelector(({ MainSale }) => MainSale.getAmountDiff)
  const showNumPadForPayment = useSelector(
    ({ Sell }) => Sell.showNumPadForPayment
  )
  const enableTaxCode = useSelector(({ MainSale }) => MainSale.enableTaxCode)
  const cartMainClass = useSelector(({ MainSale }) => MainSale.cartMainClass)
  const [getPayMode, setPayMode] = React.useState(PAY_PAY_MODE.SALE)
  const [showToolTip, setShowTooltip] = React.useState(false)

  React.useEffect(() => {
    form.setFieldsValue({ AmountToPay: formAmountToPay })
  }, [formAmountToPay])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const statusid = getDecryptID(getCurrentSalesOrderStatusID)
      const delivery =
        getDecryptID(fetchCurrentSalesOrder('Delivery, unfulfilled')) ||
        getDecryptID(fetchCurrentSalesOrder('Delivery, completed'))
      const pickup =
        getDecryptID(fetchCurrentSalesOrder('PickUp, unfulfilled')) ||
        getDecryptID(fetchCurrentSalesOrder('PickUp, completed'))
      if (statusid == delivery || statusid == pickup) {
        disableAccLayBy(getSalesOrderStatuses, dispatch)
      }
    }

    return () => (mounted = false)
  }, [getCurrentSalesOrderStatusID])

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      //tooltip for customer
      if (
        isEmptyObject(getCustomerObj) &&
        getReduxStoreOutlets &&
        getReduxStoreOutlets.length > 0
      ) {
        let outlet = outletid
          ? getReduxStoreOutlets.filter(
              a => getDecryptID(a.id) == getDecryptID(outletid)
            )
          : false
        if (outlet && outlet.length > 0) {
          outlet = outlet[0]
          if (outlet.warnForCustomer) {
            setShowTooltip(true)
          }
        }
      }
    }
    return () => (mounted = false)
  }, [])

  async function postSalesOrderPayments (body) {
    const cashRegPay = localStorage.getItem('cashManageID')
    if (cashRegPay && cashRegPay != '') {
      body.CashRegPaymentID = cashRegPay
      const postSalePaymentData = ds.postSalePaymentData(
        body,
        BEHAVIOUR_TYPE.POST,
        'PaymentPanelAction'
      )
      await postSalePaymentData
        .then(res => {
          dispatch(loadIsPaymentPanelLoading(false))
          if (res) {
            if (res.alreadyCompleted) {
              message.info('Sale has already been completed', 4)
              dispatch(loadPaymentStatusData(res))
              dispatch(loadIsShowCompleteSale(true)) // to catch data on sell screen
            } else if (res.isPaid) {
              dispatch(loadPaymentStatusData(res))
              dispatch(loadIsShowCompleteSale(true)) // to catch data on sell screen
              if (res.earnedLoyalty > 0) {
                dispatch(
                  loadEarnedLoyalty(getEarnedLoyalty + res.earnedLoyalty)
                )
              } else {
                dispatch(loadEarnedLoyalty(0))
              }
            } else {
              if (
                res.message &&
                res.message.toLowerCase().includes('not enough store balance')
              ) {
                message.warn('Do not have enough balance', 4)
              }
            }
          }
        })
        .catch(e => {
          dispatch(loadIsPaymentPanelLoading(false))
          notAllowMsgCheck(e)
          dispatch(loadIsMainLoading(false))
        })
    } else {
      message.warn('Unable to pay ...')
    }
  }

  const onFinish = values => {
    // setIsMainLoading(true);
    dispatch(loadIsMainLoading(true))
  }

  const onFinishFailed = errorInfo => {}

  const handleChangeAmountToPay = res => {
    let orderGuidID = getSalesOrderID()
    if (res == 0 || res) {
      // check if some amount remains then disable layby && onAccount option
      const checkStatusPay = getSaleOrderJson.TotalPrice - res
      if (checkStatusPay > 0) {
        disableAccLayBy(getSalesOrderStatuses, dispatch)
      } else {
        EnableDisableSaleStatusesByCustomer(
          dispatch,
          getCustomerSearchData,
          getSalesOrderStatuses,
          getLaySalePerm,
          getAccountSalePerm,
          getIsRefundSale,
          getCurrentSalesOrderStatusID
        )
      }

      const remaining =
        customParse(getSaleOrderJson.AmountToPay) - customParse(res)
      dispatch(loadSaleRemainingAmount(customParse(remaining)))
      // if (remaining > 0) dispatch(loadSaleRemainingAmount(customParse(remaining).toFixed(getDefaultDecimalPlaces)))
      // else loadSaleRemainingAmount(0);
      dispatch(loadFormAmountToPay(customParse(res)))
      let data = {
        orderGuidID: orderGuidID, // isOnline ? orderGuidID : getSaleOrderJson.indexKey,
        amount: customParse(res)
      }
      dispatch(loadSalePaymentData(data))
      closingNumPad(dispatch)
    } else {
      message.info('Information Required')
    }
  }

  const RemoveCustomerSaleStatuses = () => {
    const tempsaleStatuses =
      getSalesOrderStatuses &&
      getSalesOrderStatuses.map(e => {
        return {
          SalesOrderStatuID: e.SalesOrderStatuID,
          StatusName: e.StatusName,
          IsActive: e.IsActive,
          IsDisabled: true
        }
      })
    dispatch(loadSalesOrderStatuses(tempsaleStatuses))
  }

  const handleCustomerDelete = () => {
    dispatch(loadCustomerObj({}))
    RemoveCustomerSaleStatuses()
    dispatch(loadCustomerSearchData({}))
    let items = getReduxSaleProductJsonData
    if (items && items.length > 0) {
      let sProducts = getReduxSaleProductJsonData
      //NOTE: there is need to call again the prod builder method for working properly of removing the customer (entire sale off scenario where ref work for the whole sale)
      items.map(item => {
        const productsClone = SellProductJsonBuilder(
          item,
          undefined,
          '',
          {},
          getReduxSaleProductJsonData,
          getStoredBooks,
          getIsLoyaltyEnabled,
          getDefaultLoyaltyAmount,
          getIsTaxExclusive,
          getStoredPromos,
          getDefaultDecimalPlaces,
          getSelectedOutlet,
          getSelectedReg,
          getBasicIsPercent,
          getIsRefundSale,
          getCurrentSalesOrderData,
          getCurrentSalesOrderStatusID,
          formDiscCurr,
          formDiscPer,
          formSellNote,
          getRefundKeys,
          getSalePayments,
          dispatch,
          false,
          getSavings,
          'handleCustomerDelete-PaymentPanelAction',
          false,
          sellSelAttributes
        )
        if (productsClone && !isEmptyObject(productsClone)) {
          if (
            productsClone.key &&
            sProducts.filter(a => a.key === productsClone.key)[0]
          ) {
            let index = sProducts.indexOf(
              sProducts.filter(a => a.key == productsClone.key)[0]
            )
            sProducts[index] = productsClone
          } else {
            sProducts = sProducts.concat(productsClone)
          }
        }
      })
      clusterCalculations(
        sProducts,
        getSelectedOutlet,
        getSelectedReg,
        getBasicIsPercent,
        getCustomerSearchData,
        getIsRefundSale,
        getDefaultDecimalPlaces,
        getCurrentSalesOrderData,
        getCurrentSalesOrderStatusID,
        formDiscCurr,
        formDiscPer,
        formSellNote,
        getRefundKeys,
        getSalePayments,
        dispatch,
        getStoredPromos,
        getIsTaxExclusive,
        false,
        getSavings,
        sellSelAttributes
      )
    }
  }

  const handleClickSaleStatus = (obj, saleOrderStatusID, StatusName) => {
    localStorage.setItem('gatewaypost', '')
    const saleNature =
      getDecryptID(saleOrderStatusID) == '1'
        ? 'Sale on Layby'
        : getDecryptID(saleOrderStatusID) == '2'
        ? 'Sale on Account'
        : ''
    const amountToPay = customParse(
      formatDigits(form.getFieldValue('AmountToPay'), getDefaultDecimalPlaces)
    )
    const totalPrice = customParse(
      formatDigits(getSaleOrderJson.TotalPrice, getDefaultDecimalPlaces)
    )
    if (amountToPay == totalPrice) {
      dispatch(loadCurrentSalesOrderStatusID(saleOrderStatusID))
      let customerData = getCustomerSearchData
      customerData.accountCredit += amountToPay
      ApplyCustomerAccountDetails(
        dispatch,
        customerData,
        getStorePaymentTypes,
        getDefaultDecimalPlaces,
        getIsRefundSale,
        returnStoreCredit,
        getIsLoyaltyEnabled,
        getIsStoreCreditEnabled
      )
      if (allowPrint) {
        CalculateReceiptTemplateJson(
          getSaleOrderJson,
          getCurrentSalesOrderData,
          getCustomerSearchData,
          getTableDataSellTax,
          dispatch,
          getReduxStoreInfo,
          getDefaultDecimalPlaces,
          getDiscountPriceTotal,
          getSalePayments,
          saleNature,
          getTableDataSellPromotion,
          getIsRefundSale,
          getSavings,
          getIsTaxExclusive,
          sellSelAttributes,
          getEarnedLoyalty,
          'payment panel action',
          enableTaxCode
        )
      }
      dispatch(
        loadIsPaymentPanelActionCompleteActive(
          true,
          'handleClickSaleStatus PaymentPanelAction'
        )
      )
    } else {
      message.warn('Amount to pay should must be equal to the Total Price', 4)
    }
  }

  function removeSpacewithLowerCaseString (name) {
    return name != undefined && name != ''
      ? name.toString().toLocaleLowerCase().trim().replaceAll(/\s/g, '')
      : ''
  }

  const handleClickStorePayments = data => {
    localStorage.setItem('gatewaypost', '')
    let amountToPay = 0
    let remainingAmount = 0 //ye wo amount hy jo after store credit and loyalty consume hony k bd hogi
    let customerData = getCustomerSearchData
    // let customerData = getCustomerObj;
    let orderGuidID = getSalesOrderID()
    if (customerData.customerSId != '') {
      disableAccLayBy(getSalesOrderStatuses, dispatch)
      if (removeSpacewithLowerCaseString(data.GatewayName) == 'storecredit') {
        if (true) {
          // !getIsRefundSale
          amountToPay = customParse(form.getFieldValue('AmountToPay'))
          const customerCreditAmount = customParse(
            customerData.storeCredit ? customerData.storeCredit : 0
          )
          if (getIsRefundSale && amountToPay < 0) {
            remainingAmount = customerCreditAmount + amountToPay * -1
          } else if (amountToPay < customerCreditAmount) {
            remainingAmount = customerCreditAmount - amountToPay
          } else {
            remainingAmount = 0
          }
          const existingStoreCredit = customerData.storeCredit
            ? customerData.storeCredit
            : 0
          customerData.storeCredit = remainingAmount
          if (
            getDecryptID(getCurrentSalesOrderStatusID) == '1' ||
            getDecryptID(getCurrentSalesOrderStatusID) == '2'
          ) {
            const customer = onAccLayBySaleEffects(
              // this effect only accCredit of customer
              customerData,
              getAccLaybyCreditAmount,
              amountToPay,
              existingStoreCredit,
              dispatch
            )
            if (customer && !isEmptyObject(customer)) {
              customerData = customer
            }
          }
          ApplyCustomerAccountDetails(
            dispatch,
            customerData,
            getStorePaymentTypes,
            getDefaultDecimalPlaces,
            getIsRefundSale,
            returnStoreCredit,
            getIsLoyaltyEnabled,
            getIsStoreCreditEnabled
          )

          // dispatch(loadSalePaymentData(data));
          dispatch(loadIsPaymentPanelLoading(true))
          let body = {
            BehaviorName: 1,
            SalesOrderID: orderGuidID,
            PaymentTypeID: data.sStorePaymentTypeID,
            PaymentAmount: amountToPay,
            IsStorePayment: true,
            CustomerID: customerData.customerSId,
            isRefund: getIsRefundSale
          }
          postSalesOrderPayments(body)
        } else {
        }
      } else if (
        removeSpacewithLowerCaseString(data.GatewayName) == 'loyalty'
      ) {
        if (!getIsRefundSale) {
          amountToPay = customParse(form.getFieldValue('AmountToPay'))
          const customerLoyaltyAmount = customParse(customerData.loyaltyValue)
          if (amountToPay < customerLoyaltyAmount) {
            remainingAmount = customerLoyaltyAmount - amountToPay
          } else {
            remainingAmount = 0
          }
          const existingLoyalty = customerData.loyaltyValue
          customerData.loyaltyValue = remainingAmount
          if (
            getDecryptID(getCurrentSalesOrderStatusID) == '1' ||
            getDecryptID(getCurrentSalesOrderStatusID) == '2'
          ) {
            const customer = onAccLayBySaleEffects(
              // this effect only accCredit of customer
              customerData,
              getAccLaybyCreditAmount,
              amountToPay,
              existingLoyalty,
              dispatch
            )
            if (customer && !isEmptyObject(customer)) {
              customerData = customer
            }
          }
          ApplyCustomerAccountDetails(
            dispatch,
            customerData,
            getStorePaymentTypes,
            getDefaultDecimalPlaces,
            getIsRefundSale,
            returnStoreCredit,
            getIsLoyaltyEnabled,
            getIsStoreCreditEnabled
          )
          dispatch(loadIsPaymentPanelLoading(true))
          let body = {
            BehaviorName: 1,
            SalesOrderID: orderGuidID,
            PaymentTypeID: data.sStorePaymentTypeID,
            PaymentAmount: amountToPay,
            IsStorePayment: true,
            CustomerID: customerData.customerSId,
            isRefund: getIsRefundSale
          }
          postSalesOrderPayments(body)
        }
      }
      const tempStorePaymentTypes =
        getStorePaymentTypes &&
        getStorePaymentTypes.map(e => {
          let isDisabled = true
          if (e.GatewayName == 'storecredit') {
            if (getIsRefundSale) {
              if (amountToPay > 0) {
                isDisabled =
                  getIsStoreCreditEnabled && remainingAmount > 0 ? false : true
              } else if (amountToPay < 0) {
                isDisabled = returnStoreCredit ? false : true
              }
            } else {
              isDisabled =
                getIsStoreCreditEnabled && remainingAmount > 0 ? false : true
            }
          } else if (e.GatewayName == 'loyalty') {
            isDisabled =
              !getIsRefundSale && getIsLoyaltyEnabled && remainingAmount > 0
                ? false
                : true
          }
          return {
            sStorePaymentTypeID: e.sStorePaymentTypeID,
            PaymentTypeName: e.PaymentTypeName,
            GatewayName: e.GatewayName,
            IsDisabled: isDisabled
          }
        })
      dispatch(loadStorePaymentTypes(tempStorePaymentTypes))
    }
  }

  function clickForNumPad (type, data) {
    // NOTE: 5 type for amount to pay
    dispatch(loadShowNumPadForPay(true))
    dispatch(loadNumPadType(type))
    dispatch(loadNumRelateData(data))
  }

  // function calculateRemaining(){
  //   const val = formAmountToPay;
  // }

  return (
    <Card className={`APD-Wrapper ${cartMainClass}`}>
      <Spin
        tip={<IntlMessages id='common.resource.loading' />}
        spinning={getSaleCompleted || getIsPaymentPanelLoading}
        size='large'
      >
        <div class='Payment-Carent-div'>
          <div class='Payment-type-div'>
            {showNumPadForPayment && (
              <NumPad
                callback={handleChangeAmountToPay}
                from='paymentPanelAction'
              />
            )}
            <Form
              name='SellForm'
              form={form}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              scrollToFirstError
              {...formItemLayout}
            >
              {getIsRefundSale ? (
                <>
                  <Form.Item
                    className='ant-form-item-label-custom--payment ant-form-custom-alignment payment-form gx-pd-0  gx-mb-0'
                    name='AmountToPay'
                    label={<IntlMessages id='right.pay.panel' />}
                  >
                    <div
                      className='amount-to-pay--input gx-mr-0'
                      onClick={() =>
                        clickForNumPad(
                          NumPadTypes.AMOUNT_TO_PAY,
                          formAmountToPay
                        )
                      }
                    >
                      {formatDigits(formAmountToPay, getDefaultDecimalPlaces)}
                    </div>
                    {/* <InputNumber
                size='middle'
                className='amount-to-pay--input gx-mr-0'
                // onChange={e => {
                //   handleChangeAmountToPay(e)
                // }}
                // onBlur={() => dispatch(loadIsPaymentPanelLoading(true))}
                value={formatDigits(formAmountToPay, getDefaultDecimalPlaces)}
                width={'100%'}
                onClick={() =>
                  clickForNumPad(NumPadTypes.AMOUNT_TO_PAY, formAmountToPay)
                }
              /> */}
                  </Form.Item>
                </>
              ) : (
                <>
                  <div className='dk-main-amount-to-pay'>
                    <div
                      className={`dk-text-hero ${
                        singleScreen ? 'text-shrink' : ''
                      } dk-font-weight-300`}
                    >
                      <IntlMessages id='right.pay.panel' />
                    </div>
                    <Form.Item
                      className='ant-form-item-label-custom--payment ant-form-custom-alignment payment-form gx-mb-0'
                      name='AmountToPay'
                      style={{ cursor: 'pointer' }}
                    >
                      <div
                        className='amount-to-pay--input gx-mr-0'
                        onClick={() =>
                          clickForNumPad(
                            NumPadTypes.AMOUNT_TO_PAY,
                            formAmountToPay
                          )
                        }
                      >
                        {formatDigits(formAmountToPay, getDefaultDecimalPlaces)}
                      </div>
                      {/* <InputNumber
                  size='middle'
                  className='amount-to-pay--input gx-mr-0'
                  // onChange={e => {
                  //   if (e >= 0) {
                  //     handleChangeAmountToPay(e)
                  //   }
                  // }}
                  width={'100%'}
                  min={0}
                  // onBlur={() => dispatch(loadIsPaymentPanelLoading(true))}
                  value={formatDigits(formAmountToPay, getDefaultDecimalPlaces)}
                  onClick={() =>
                    clickForNumPad(NumPadTypes.AMOUNT_TO_PAY, formAmountToPay)
                  }
                /> */}
                    </Form.Item>
                  </div>
                </>
              )}
              <div className='dk-change-partial'>
                {getAmountDiff && customParse(getAmountDiff) > 0 ? (
                  <span>
                    <IntlMessages id='mainsale.sell.remamount' />
                    {` ${formatDigits(getAmountDiff, getDefaultDecimalPlaces)}`}
                  </span>
                ) : getIsSalePaymentProcessStart &&
                  getSaleOrderJson &&
                  getSaleOrderJson.Change ? (
                  <span style={{ fontSize: 'x-large', fontWeight: 600 }}>
                    <bold>{`CHANGE: ${
                      getCurrData.currencySymbol != null
                        ? getCurrData.currencySymbol
                        : getCurrData.currencyName != null
                        ? getCurrData.currencyName
                        : getCurrData.currencyCode
                        ? getCurrData.currencyCode
                        : ''
                    } ${formatDigits(
                      getSaleOrderJson.Change,
                      getDefaultDecimalPlaces
                    )}`}</bold>
                  </span>
                ) : (
                  <span>
                    <IntlMessages id='mainsale.sell.partialPay' />
                  </span>
                )}
              </div>

              {/* <Form.Item
              className="ant-form-item-label-custom--payment ant-form-custom-alignment payment-form"
              name="AmountToPay"
              style={{ marginTop: -18 }}
            >
              
            </Form.Item> */}
            </Form>
            <div className='payment-type-button-group dk-btn-group'>
              <PaymentTypesModal
                isSellScreen={true}
                mode={getPayMode}
                isRefund={getIsRefundSale}
                returnStoreCredit={returnStoreCredit}
              />
            </div>

            <div className='dk-mt20 dk-mb20'>
              <Tooltip
                placement='left'
                title={
                  <div>
                    <strong style={{ color: '#ffff' }}>
                      <InfoCircleOutlined style={{ display: 'contents' }} />
                      <span style={{ marginLeft: 8 }}>
                        <IntlMessages id='sell.cart.customer' />
                      </span>
                    </strong>
                    <br />
                    <IntlMessages id='sell.cart.cusdecrptn' />
                    <Button
                      type='primary'
                      size='middle'
                      onClick={() => setShowTooltip(false)}
                      style={{ marginTop: 5, marginLeft: 5 }}
                    >
                      <IntlMessages id='sell.cart.customerbtn' />
                    </Button>
                    {/* <Row>
                <Col>
                  <h3>
                    <InfoCircleOutlined />
                    <IntlMessages id="sell.cart.customer" />
                  </h3>
                </Col>
              </Row>
              <Row style={{ marginTop: 8 }}>
                <Col>
                  <IntlMessages id="sell.cart.cusdecrptn" />
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }} justify="end">
                <Col>
                  <Button
                    type="primary"
                    size="middle"
                    onClick={() => setShowTooltip(false)}
                  >
                    <IntlMessages id="sell.cart.customerbtn" />
                  </Button>
                </Col>
              </Row> */}
                  </div>
                }
                visible={showToolTip && !showNumPadForPayment && !singleScreen}
              >
                <Form
                  {...formItemLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    prefix: '86'
                  }}
                  // className=""
                  scrollToFirstError
                  id='SellForm'
                  name='SellForm'
                  className='custom-bg-white'
                >
                  {getCustomerObj && getCustomerObj.customerCode ? (
                    <>
                      <Card
                        className='sell-account-card payment-boxes-card'
                        title={
                          !singleScreen && (
                            <div className='gx-module-list-icon'>
                              <Row className='gx-mr-0 gx-ml-0'>
                                <Col>
                                  <div className='gx'>
                                    <Avatar
                                      style={{ fontWeight: 'bold' }}
                                      className={`gx-avatar gx-bg-${
                                        true == 'even' ? 'green' : 'blue'
                                      } gx-size-46 mr-10`}
                                    >
                                      {getCustomerObj.letterName
                                        ? getCustomerObj.letterName
                                        : '00'}
                                    </Avatar>
                                  </div>
                                </Col>

                                <Col className='ml-2'>
                                  <div className='gx-module-list-content'>
                                    <div className='gx-mail-user-des mb-0'>
                                      <span className='gx-sender-name'>
                                        {getCustomerObj.customerFirstName
                                          ? getCustomerObj.customerFirstName
                                          : ' '}
                                        {getCustomerObj.customerLastName
                                          ? getCustomerObj.customerLastName
                                          : ' '}
                                      </span>

                                      <span className='gx-toolbar-separator'>
                                        &nbsp;
                                      </span>

                                      <span className='vd-flag sm:hidden'>
                                        {getCustomerObj.groupName
                                          ? getCustomerObj.groupName
                                          : 'All Customers'}
                                      </span>
                                    </div>
                                    <div className='gx-message'>
                                      <p className='gx-text-truncate'>
                                        {getCustomerObj.customerCode
                                          ? getCustomerObj.customerCode
                                          : '000-ABC'}
                                      </p>
                                    </div>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          )
                        }
                        extra={
                          !singleScreen &&
                          (getDecryptID(getCurrentSalesOrderStatusID) !== '2' &&
                          getDecryptID(getCurrentSalesOrderStatusID) !== '1' &&
                          getDecryptID(getCurrentSalesOrderStatusID) !== '4' &&
                          getDecryptID(getCurrentSalesOrderStatusID) !== '5' ? (
                            <div className='del-btn-div'>
                              <a
                                onClick={() => handleCustomerDelete()}
                                className='trash-icon-btn'
                              >
                                <i className='icon icon-trash' />
                              </a>
                            </div>
                          ) : (
                            <LockOutlined />
                          ))
                        }
                      >
                        <List
                          className='payment-boxes'
                          grid={{
                            gutter: 8,
                            column:
                              getCustomerAccountDetails &&
                              getCustomerAccountDetails.length > 2
                                ? 3
                                : 2
                          }}
                          dataSource={getCustomerAccountDetails}
                          renderItem={item => (
                            <List.Item>
                              <Card
                                className='custom-text-center dk-mgb-15'
                                title={item.AmountType}
                              >
                                <h1>{item.Amount}</h1>
                              </Card>
                            </List.Item>
                          )}
                        />
                      </Card>
                    </>
                  ) : (
                    <>
                      {!singleScreen && <SearchCustomer screen='SellScreen' />}
                    </>
                  )}
                </Form>
              </Tooltip>
            </div>

            {singleScreen && <Divider className='custom-promolist-divider' />}

            <div className='payment-type-button-group dk-btn-group'>
              {getSalesOrderStatuses &&
                getSalesOrderStatuses
                  .filter(x => x.IsActive != false)
                  .map((e, key) => {
                    return (
                      <Button
                        key={key}
                        value={e.SalesOrderStatusID}
                        className='dk-btn-store-payments btn--payment-type dk-mgr-4'
                        type='primary'
                        onClick={i =>
                          handleClickSaleStatus(
                            i,
                            e.SalesOrderStatuID,
                            e.StatusName
                          )
                        }
                        disabled={
                          e.IsDisabled ||
                          getIsSalePaymentProcessStart ||
                          !isOnline
                        }
                        block
                      >
                        {e.StatusName}
                      </Button>
                    )
                  })}

              {getStorePaymentTypes &&
                getStorePaymentTypes.map((e, key) => {
                  return (
                    <Button
                      key={key}
                      value={e.sStorePaymentTypeID}
                      className='dk-btn-store-payments btn--payment-type dk-mgr-4'
                      type='primary'
                      disabled={e.IsDisabled || !isOnline}
                      onClick={() => handleClickStorePayments(e)}
                    >
                      {e.PaymentTypeName}
                    </Button>
                  )
                })}
            </div>
          </div>

          {singleScreen && (
            <PaymentPanelSummaryHelper_1 getCurrData={getCurrData} />
          )}
        </div>
      </Spin>
    </Card>
  )
}

export default PaymentPanelAction
